import { chakra } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

import { useSearchInputStyles } from '../SearchInputStylesContext';
import { useSearchInputContext } from '../utils';

export type HintWrapperProps = PropsWithChildren<{
  value: string | undefined | null;
}>;

export const HintWrapper = ({ value, children }: HintWrapperProps) => {
  const { paddingLeft, paddingRight } = useSearchInputContext();

  const { hintWrapper: hintWrapperStyles } = useSearchInputStyles();

  return (
    <chakra.span
      __css={{
        ...hintWrapperStyles,
        left: paddingLeft,
        right: paddingRight,
      }}
      aria-hidden="true"
    >
      {value && <chakra.span color="transparent">{value}</chakra.span>}
      {children}
    </chakra.span>
  );
};
